import { ReactNode } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { cn } from '../../lib/utils'

/**
 * Slides the mandate page in from the right when it was opened from the inbox
 * (the spatial model: the inbox sits behind, the task detail slides over it).
 * Gated on the navigation origin, so opening a mandate from an email, the
 * history or a direct URL is a plain load, never an arbitrary slide.
 *
 * Keyed by the mandate id so the animation replays on the serial queue's
 * auto-advance (mandate A -> B, same route). The wrapper stays mounted across
 * MandateDetails' own loading -> loaded swap, so the page slides in once (as a
 * skeleton) and fills in place, rather than sliding twice or flashing.
 */
export function MandateRouteTransition({ children }: { children: ReactNode }) {
  const { id } = useParams<{ id: string }>()
  const location = useLocation()
  const fromInbox = typeof location.state?.from === 'string' && location.state.from.startsWith('/home/tasks')

  return (
    <div
      key={id}
      className={cn(
        'h-full',
        fromInbox && 'motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-right-6 motion-safe:duration-200',
      )}
    >
      {children}
    </div>
  )
}
